import { CHATBOT_CONFIG } from '@common/constants'
import { useLoadScript } from './useLoadScript'

export const useChatbot = (enableChatBot: boolean) => {
    ;(window as any).KHOROS_CONFIG = CHATBOT_CONFIG

    return useLoadScript(`https://js.qualified.com/qualified.js?token=hUipxtRKEHpLVXaK`, enableChatBot)
}
